import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function OutstationCabServiceNaviMumbai() {



    const cardData = {





keyword: "Outstation Cab Service Navi Mumbai",

headingDescription: "Shreesha Tours & Travels offers reliable Outstation Cab Service in Navi Mumbai for family vacations, business trips, pilgrimage tours, weekend getaways, corporate travel, one-way journeys, and round-trip travel across Maharashtra and nearby destinations. We provide a wide range of chauffeur-driven vehicles including Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium cars for comfortable long-distance journeys. With experienced drivers, clean and well-maintained vehicles, transparent pricing, doorstep pickup, flexible travel options, and 24/7 customer support, we ensure a safe and convenient outstation travel experience. Whether you are planning a short trip or a long-distance road journey, Shreesha Tours & Travels provides dependable Navi Mumbai outstation cab services with complete comfort and reliability.",

topPlaces: [
  {
    title: "Navi Mumbai to Pune Outstation Cab",
    description: "Pune is one of the most popular outstation destinations from Navi Mumbai, known for IT parks, educational institutes, historical monuments, and cultural attractions. Travelers can explore Shaniwar Wada, Aga Khan Palace, Sinhagad Fort, Dagdusheth Ganpati Temple, Koregaon Park, Hinjawadi, and Kharadi business areas. An outstation cab provides a comfortable option for corporate meetings, family visits, and weekend travel."
  },
  {
    title: "Navi Mumbai to Goa Outstation Cab",
    description: "Goa is a favorite holiday destination offering beautiful beaches, Portuguese heritage, forts, nightlife, water sports, and luxury resorts. Travelers can visit Baga Beach, Calangute Beach, Fort Aguada, Dudhsagar Waterfalls, Panaji, and South Goa attractions. A private outstation cab from Navi Mumbai allows a relaxed road trip experience with flexible stops and comfortable travel."
  },
  {
    title: "Navi Mumbai to Shirdi Outstation Cab",
    description: "Shirdi is a major pilgrimage destination famous for Sai Baba Samadhi Temple, Dwarkamai, Chavadi, and other spiritual attractions. Devotees from Navi Mumbai frequently travel to Shirdi with family members and senior citizens. Outstation taxi services provide comfortable seating, direct travel, and convenient pickup and drop facilities for a peaceful pilgrimage journey."
  },
  {
    title: "Navi Mumbai to Mahabaleshwar Outstation Cab",
    description: "Mahabaleshwar is a beautiful hill station known for Venna Lake, Arthur's Seat, Mapro Garden, strawberry farms, Pratapgad Fort, and scenic viewpoints. It is a perfect destination for family vacations, honeymoon trips, and nature lovers. An outstation cab makes hill station travel easier with comfortable vehicles suitable for mountain roads."
  },
  {
    title: "Navi Mumbai to Kolhapur Outstation Cab",
    description: "Kolhapur is a historic destination famous for Mahalaxmi Temple, Panhala Fort, Rankala Lake, Jyotiba Temple, and traditional Kolhapuri culture. The city attracts pilgrims, tourists, and business travelers throughout the year. A private cab service offers a smooth long-distance journey with flexible travel schedules."
  },
  {
    title: "Navi Mumbai to Nashik Outstation Cab",
    description: "Nashik is known for Trimbakeshwar Jyotirlinga, Panchavati, Ramkund, Sula Vineyards, Pandavleni Caves, and beautiful religious and natural attractions. It is a popular destination for pilgrimage, wine tourism, and business travel. Outstation taxi service from Navi Mumbai provides convenient transportation for individuals, families, and groups."
  },
  {
    title: "Navi Mumbai to Ratnagiri Outstation Cab",
    description: "Ratnagiri is a beautiful Konkan destination famous for Ganpatipule Temple, Ratnadurg Fort, Aare Ware Beach, Thiba Palace, and Alphonso mango farms. Travelers enjoy coastal scenery, peaceful beaches, and heritage locations. A comfortable outstation cab ensures a memorable road journey through the scenic Konkan route."
  },
  {
    title: "Navi Mumbai to Lonavala Outstation Cab",
    description: "Lonavala is a popular getaway destination offering Tiger Point, Bhushi Dam, Pawna Lake, Karla Caves, Rajmachi Fort, and Della Adventure Park. It is ideal for weekend trips, family outings, and corporate tours. Outstation cab services provide flexible sightseeing options and comfortable return travel."
  },
  {
    title: "Navi Mumbai to Aurangabad Outstation Cab",
    description: "Aurangabad is a historical and cultural destination known for Ajanta Caves, Ellora Caves, Grishneshwar Jyotirlinga, Daulatabad Fort, and Bibi Ka Maqbara. Travelers can enjoy a combination of heritage sightseeing and religious visits. A private outstation taxi offers comfortable travel for multi-day tours with family and groups."
  },
  {
    title: "Navi Mumbai to Saputara Outstation Cab",
    description: "Saputara is Gujarat's beautiful hill station known for Saputara Lake, Sunset Point, Ropeway, Gira Waterfalls, Artist Village, and green valleys. It is a peaceful destination for nature lovers and family holidays. Outstation cab services provide convenient travel from Navi Mumbai with comfortable vehicles and experienced drivers."
  }
],


"services": [
  {
    "name": "Cab Hire in Navi Mumbai",
    "description": "Hire Cab in Navi Mumbai for comfortable and reliable local as well as outstation travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and luxury cars for family trips, business travel, airport transfers, and long-distance journeys."
  },
  {
    "name": "Outstation Cab Service Navi Mumbai",
    "description": "Book Outstation Cab Service Navi Mumbai for safe and convenient intercity travel with experienced drivers and premium vehicles. Enjoy affordable one-way and round-trip cab services from Navi Mumbai to Pune, Mumbai, Shirdi, Nashik, Lonavala, and other destinations."
  },
  {
    "name": "Navi Mumbai Outstation Taxi",
    "description": "Choose Navi Mumbai Outstation Taxi for reliable long-distance transportation with clean AC cars and professional chauffeurs. Get comfortable travel solutions for family vacations, corporate trips, sightseeing tours, and personal journeys."
  },
  {
    "name": "Outstation Taxi Service from Navi Mumbai",
    "description": "Book Outstation Taxi Service from Navi Mumbai for smooth and hassle-free travel across Maharashtra and nearby states. Enjoy punctual pickup, flexible travel options, and chauffeur-driven cabs suitable for every type of outstation journey."
  },
  {
    "name": "Book Outstation Cab Navi Mumbai",
    "description": "Book Outstation Cab Navi Mumbai online with quick confirmation, transparent pricing, and multiple vehicle options. Travel comfortably with experienced drivers and well-maintained cars for one-way, round-trip, and multi-day outstation trips."
  },
  {
    "name": "Best Outstation Cab Service Navi Mumbai",
    "description": "Choose Best Outstation Cab Service Navi Mumbai for safe, affordable, and comfortable long-distance travel. Our premium fleet and professional chauffeurs ensure a smooth journey for families, corporate travelers, and tourists."
  },
  {
    "name": "AC Outstation Cab Navi Mumbai",
    "description": "Hire AC Outstation Cab Navi Mumbai for relaxing travel with clean air-conditioned vehicles and experienced drivers. Enjoy comfortable journeys with spacious seating, luggage space, and reliable transportation services."
  },
  {
    "name": "Private Outstation Taxi Navi Mumbai",
    "description": "Book Private Outstation Taxi Navi Mumbai for personalized travel with dedicated vehicles and professional chauffeurs. Enjoy privacy, flexible schedules, and comfortable rides for personal, family, and business trips."
  },
  {
    "name": "Affordable Outstation Cab Navi Mumbai",
    "description": "Get Affordable Outstation Cab Navi Mumbai with competitive fares and quality service. Select from multiple car categories with transparent charges, comfortable interiors, and reliable drivers for short and long-distance travel."
  },
  {
    "name": "Reliable Outstation Taxi from Navi Mumbai",
    "description": "Choose Reliable Outstation Taxi from Navi Mumbai for punctual service, safe driving, and comfortable journeys. Travel with verified chauffeurs and well-maintained vehicles for stress-free outstation transportation."
  },
  {
    "name": "24x7 Outstation Cab Service Navi Mumbai",
    "description": "Book 24x7 Outstation Cab Service Navi Mumbai for round-the-clock travel assistance. Get instant cab availability for airport transfers, emergency travel, family trips, business journeys, and long-distance destinations."
  },
  {
    "name": "Outstation Cab Navi Mumbai Fare",
    "description": "Check Outstation Cab Navi Mumbai Fare with transparent pricing and affordable packages. Choose suitable vehicles including Sedan, Ertiga, Innova, Innova Crysta, SUV, and premium cars based on your travel requirements."
  },
  {
    "name": "Navi Mumbai Outstation Taxi Charges",
    "description": "Get Navi Mumbai Outstation Taxi Charges with competitive rates and no hidden costs. Enjoy reliable chauffeur-driven taxi services with flexible packages for one-way and round-trip travel."
  },
  {
    "name": "Cheapest Outstation Cab in Navi Mumbai",
    "description": "Book Cheapest Outstation Cab in Navi Mumbai for budget-friendly travel without compromising safety and comfort. Enjoy economical cab options with experienced drivers and quality vehicles for every destination."
  },
  {
    "name": "Outstation Cab Booking Navi Mumbai",
    "description": "Complete Outstation Cab Booking Navi Mumbai easily with instant confirmation and flexible travel options. Select from a wide range of vehicles for family trips, corporate travel, airport transfers, and sightseeing."
  },
  {
    "name": "Navi Mumbai Outstation Cab Price",
    "description": "Get Navi Mumbai Outstation Cab Price with affordable travel packages and multiple vehicle choices. Compare sedan, SUV, MUV, and luxury cab options according to passengers, luggage, and destination."
  },
  {
    "name": "Innova Crysta Outstation Cab Navi Mumbai",
    "description": "Book Innova Crysta Outstation Cab Navi Mumbai for premium long-distance travel with spacious seating, luxury interiors, and experienced chauffeurs. Ideal for family vacations, corporate journeys, and group travel."
  },
  {
    "name": "Ertiga Outstation Cab Navi Mumbai",
    "description": "Choose Ertiga Outstation Cab Navi Mumbai for comfortable and affordable family travel. Enjoy spacious seating, clean AC vehicles, and reliable chauffeur services for outstation destinations."
  },
  {
    "name": "Swift Dzire Outstation Taxi Navi Mumbai",
    "description": "Hire Swift Dzire Outstation Taxi Navi Mumbai for economical and comfortable travel. Perfect for couples, small families, business trips, and one-way journeys with professional drivers."
  },
  {
    "name": "Sedan Outstation Cab Navi Mumbai",
    "description": "Book Sedan Outstation Cab Navi Mumbai for budget-friendly long-distance travel with comfortable AC cars and experienced chauffeurs. Enjoy smooth rides for personal and corporate requirements."
  },
  {
    "name": "SUV Outstation Taxi Navi Mumbai",
    "description": "Choose SUV Outstation Taxi Navi Mumbai for spacious and comfortable travel with extra luggage capacity. Ideal for family tours, group trips, and long-distance journeys from Navi Mumbai."
  },
  {
    "name": "Navi Mumbai to Pune Outstation Cab",
    "description": "Book Navi Mumbai to Pune Outstation Cab for safe and convenient travel with premium vehicles and experienced drivers. Enjoy one-way and round-trip services with flexible pickup options."
  },
  {
    "name": "Navi Mumbai to Mumbai Outstation Taxi",
    "description": "Hire Navi Mumbai to Mumbai Outstation Taxi for reliable city-to-city transportation with comfortable vehicles and professional chauffeurs. Suitable for business travel, airport transfers, and personal trips."
  },
  {
    "name": "Navi Mumbai to Shirdi Cab",
    "description": "Book Navi Mumbai to Shirdi Cab for comfortable religious travel with experienced drivers and spacious vehicles. Choose Innova, Ertiga, Sedan, and premium cabs for Sai Baba Darshan trips."
  },
  {
    "name": "Navi Mumbai to Nashik Outstation Cab",
    "description": "Reserve Navi Mumbai to Nashik Outstation Cab for smooth and affordable travel with professional chauffeurs. Enjoy comfortable rides for business visits, sightseeing, and family journeys."
  },
  {
    "name": "Navi Mumbai to Lonavala Outstation Taxi",
    "description": "Book Navi Mumbai to Lonavala Outstation Taxi for weekend trips and sightseeing tours with comfortable AC vehicles. Travel safely with experienced drivers and flexible one-way or round-trip options."
  },
  {
    "name": "One Way Outstation Cab Navi Mumbai",
    "description": "Choose One Way Outstation Cab Navi Mumbai for economical drop services without return charges. Enjoy flexible pickup timings and comfortable travel to your destination."
  },
  {
    "name": "Round Trip Outstation Taxi Navi Mumbai",
    "description": "Book Round Trip Outstation Taxi Navi Mumbai for return journeys with flexible schedules and reliable chauffeurs. Perfect for family vacations, business trips, and sightseeing tours."
  },
  {
    "name": "Family Outstation Cab Navi Mumbai",
    "description": "Hire Family Outstation Cab Navi Mumbai for safe and comfortable travel with spacious vehicles. Enjoy hassle-free journeys with family-friendly cars and professional drivers."
  },
  {
    "name": "Corporate Outstation Taxi Navi Mumbai",
    "description": "Book Corporate Outstation Taxi Navi Mumbai for professional business travel with punctual service and premium vehicles. Ideal for meetings, employee transportation, client visits, and corporate events."
  },
  {
    "name": "Doorstep Pickup Outstation Cab Navi Mumbai",
    "description": "Reserve Doorstep Pickup Outstation Cab Navi Mumbai for convenient pickup from your location. Enjoy hassle-free travel with verified drivers, clean vehicles, and reliable outstation transportation."
  }
],
"tableData": [
  ["Cab Hire in Navi Mumbai", "Outstation Cab Service Navi Mumbai"],
  ["Navi Mumbai Outstation Taxi", "Outstation Taxi Service from Navi Mumbai"],
  ["Book Outstation Cab Navi Mumbai", "Best Outstation Cab Service Navi Mumbai"],
  ["AC Outstation Cab Navi Mumbai", "Private Outstation Taxi Navi Mumbai"],
  ["Affordable Outstation Cab Navi Mumbai", "Reliable Outstation Taxi from Navi Mumbai"],
  ["24x7 Outstation Cab Service Navi Mumbai", "Outstation Cab Navi Mumbai Fare"],
  ["Navi Mumbai Outstation Taxi Charges", "Cheapest Outstation Cab in Navi Mumbai"],
  ["Outstation Cab Booking Navi Mumbai", "Navi Mumbai Outstation Cab Price"],
  ["Innova Crysta Outstation Cab Navi Mumbai", "Ertiga Outstation Cab Navi Mumbai"],
  ["Swift Dzire Outstation Taxi Navi Mumbai", "Sedan Outstation Cab Navi Mumbai"],
  ["SUV Outstation Taxi Navi Mumbai", "Navi Mumbai to Pune Outstation Cab"],
  ["Navi Mumbai to Mumbai Outstation Taxi", "Navi Mumbai to Shirdi Cab"],
  ["Navi Mumbai to Nashik Outstation Cab", "Navi Mumbai to Lonavala Outstation Taxi"],
  ["One Way Outstation Cab Navi Mumbai", "Round Trip Outstation Taxi Navi Mumbai"],
  ["Family Outstation Cab Navi Mumbai", "Corporate Outstation Taxi Navi Mumbai"],
  ["Doorstep Pickup Outstation Cab Navi Mumbai", ""]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Outstation Cab Service in Navi Mumbai",
    WhyChoosedescription: "Shreesha Travels provides dependable outstation cab services from Navi Mumbai for family trips, business travel, weekend getaways, pilgrimage tours, and long-distance journeys. Enjoy comfortable rides with professional chauffeurs and well-maintained vehicles."
  },
  {
    WhyChooseheading: "Travel Across Maharashtra & India with Ease",
    WhyChoosedescription: "Book private outstation taxis from Navi Mumbai to destinations like Pune, Lonavala, Mahabaleshwar, Shirdi, Nashik, Kolhapur, Goa, Gujarat, Rajasthan, Madhya Pradesh, and other cities across India."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles for Every Journey",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to your group size and travel needs."
  },
  {
    WhyChooseheading: "One-Way & Round Trip Outstation Options",
    WhyChoosedescription: "Select one-way cab service for direct travel or round-trip packages with flexible return schedules, multiple stops, sightseeing options, and customized itineraries."
  },
  {
    WhyChooseheading: "Perfect for Family, Corporate & Holiday Travel",
    WhyChoosedescription: "Our outstation cabs are suitable for family vacations, corporate visits, airport transfers, wedding travel, religious tours, weekend holidays, and personal journeys."
  },
  {
    WhyChooseheading: "Experienced Drivers for Highway Travel",
    WhyChooseheading: "Experienced Drivers for Highway Travel",
    WhyChoosedescription: "Our trained chauffeurs have excellent knowledge of highways and popular routes, ensuring safe driving, timely pickups, and a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Clean & Comfortable Vehicles",
    WhyChoosedescription: "Every vehicle is regularly serviced, sanitized, air-conditioned, and inspected before every trip to provide a safe, hygienic, and relaxing journey."
  },
  {
    WhyChooseheading: "Book Outstation Cab Service in Navi Mumbai with Shreesha Travels",
    WhyChoosedescription: "Get transparent pricing, quick booking assistance, professional chauffeur service, and reliable outstation transportation for all your travel requirements from Navi Mumbai."
  }
]

};

const faqData = [
  {
    question: "What destinations are covered under Navi Mumbai outstation cab service?",
    answer: "We provide outstation cab services from Navi Mumbai to Pune, Nashik, Lonavala, Mahabaleshwar, Shirdi, Goa, Kolhapur, Gujarat, Rajasthan, Madhya Pradesh, and many other destinations."
  },
  {
    question: "Can I book a one-way outstation cab from Navi Mumbai?",
    answer: "Yes, one-way outstation taxi services are available for direct travel to your preferred destination."
  },
  {
    question: "Do you provide round trip outstation cabs?",
    answer: "Yes, round trip packages are available with flexible return schedules and customized travel plans."
  },
  {
    question: "Which vehicles are available for outstation travel?",
    answer: "We offer Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles."
  },
  {
    question: "Is outstation cab service suitable for family trips?",
    answer: "Yes, our spacious vehicles and experienced chauffeurs make long-distance travel comfortable for families, children, and senior citizens."
  },
  {
    question: "Can I add sightseeing stops during an outstation trip?",
    answer: "Yes, customized travel plans with sightseeing locations and multiple stops can be arranged according to your itinerary."
  },
  {
    question: "Do you provide outstation cabs for corporate travel?",
    answer: "Yes, our services include business trips, employee transportation, client visits, factory visits, and corporate tours."
  },
  {
    question: "How is the outstation cab fare calculated?",
    answer: "The fare depends on the vehicle type, travel distance, trip duration, route, toll charges, parking fees, driver allowance, and additional requirements."
  },
  {
    question: "Are outstation cabs available for multi-day trips?",
    answer: "Yes, multi-day rental packages are available for vacations, pilgrimage tours, business travel, and customized journeys."
  },
  {
    question: "How can I book Outstation Cab Service in Navi Mumbai with Shreesha Travels?",
    answer: "Share your pickup location, destination, travel date, passenger count, and preferred vehicle to receive a customized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Karan Shah",
    feedback: "We booked an outstation cab from Navi Mumbai for a family trip. The vehicle was comfortable, the driver was experienced, and the complete journey was smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Kulkarni",
    feedback: "Excellent outstation taxi service. The booking process was simple, the pricing was transparent, and the chauffeur provided a safe and pleasant travel experience.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Outstation Cab Service Navi Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/outstation-cab-service-navi-mumbai.webp",
  "description":
    "Book Outstation Cab Service Navi Mumbai with Shreesha Tours & Travels for comfortable and reliable long-distance taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for outstation trips, family vacations, business travel, sightseeing tours, one-way journeys, round trips, and long-distance travel from Navi Mumbai with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/outstation-cab-service-navi-mumbai"
  }
};



    return (
        <div>
<Helmet>
  <title>Outstation Cab Service Navi Mumbai | Outstation Taxi Booking | +91 8355835813</title>

  <meta
    name="description"
    content="Book Outstation Cab Service Navi Mumbai with Shreesha Travels for safe and comfortable long-distance taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for one-way trips, round trips, family tours, business travel, and 24x7 outstation cab booking."
  />

  <meta
    name="keywords"
    content="Cab Hire in Navi Mumbai, Outstation Cab Service Navi Mumbai, Navi Mumbai Outstation Taxi, Outstation Taxi Service from Navi Mumbai, Book Outstation Cab Navi Mumbai, Best Outstation Cab Service Navi Mumbai, AC Outstation Cab Navi Mumbai, Private Outstation Taxi Navi Mumbai, Affordable Outstation Cab Navi Mumbai, Reliable Outstation Taxi Navi Mumbai, One Way Outstation Cab Navi Mumbai, Navi Mumbai Long Distance Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/104.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default OutstationCabServiceNaviMumbai;